/* eslint-disable max-len */
export const ERRORS_GLOBAL_MAP: { [key: string]: string } = {
  "Error: User doesn't exists.": "You must complete your information to continue",
  "UnauthorizedException: jwt expired": "Your session has expired",
  "BadRequestException: Wrong email or password.": "Incorrect Password",
  "TypeError: Cannot destructure property 'evToken' of '(intermediate value)' as it is null.": "Uh-oh, your user is missing data to be completed",
  "SERVER_ERROR": "Uh-oh, the hamsters running our servers got tired. Please give them a moment to catch their breath and try again soon.",
};

export const ERRORS_SESSIONS_MAP = [
  "InvalidTokenError",
  "UnauthorizedException: jwt expired",
  "Error: User not found, invalid token, please register first",
  "User not found, invalid token, please register first",
  "UnauthorizedException: jwt malformed",
  "UnauthorizedException: invalid signature",
  "UnauthorizedException: secret or public key must be provided",
  "User not found",
  "UnauthorizedException",
];

export const DEFAULT_ERROR = "Something went wrong, please try again.";

export const DISABLE_ALERT_MESSAGES = [
  "This phone number is already in use. Please try a different one.",
  "Payment declined. Please verify your card details or contact your bank for more information.",
  "Payment declined due to insufficient funds. Please check your account balance or try another card.",
  "Payment declined due to transaction limit. Please contact your bank for assistance.",
  "Invalid card number. Please double-check the card details and try again.",
  "The account cannot process transactions. Please contact your bank or try a different payment method.",
  "This card cannot be processed. Please use a different card or contact your bank for assistance.",
  "The card has expired. Please use a different card to complete your payment.",
  "This card type is not supported. Please use a different card or contact your bank for assistance.",
  "Payment exceeds the allowable limit. Please try a different payment method or contact your bank.",
  "An error occurred while processing your payment. Please try again later or contact support.",
  "Error: Animal not found",
];
